"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformTagApi = exports.SdPlatformTagQueryEmbeddableFields = void 0;
const SdPlatformRequestId_1 = require("../api/SdPlatformRequestId");
const ResourcesApi_1 = require("./commons/ResourcesApi");
var SdPlatformTagQueryEmbeddableFields;
(function (SdPlatformTagQueryEmbeddableFields) {
    SdPlatformTagQueryEmbeddableFields["ModelsCount"] = "models_count";
})(SdPlatformTagQueryEmbeddableFields = exports.SdPlatformTagQueryEmbeddableFields || (exports.SdPlatformTagQueryEmbeddableFields = {}));
/**
 * Operations for tags which can be attached to models.
 */
class SdPlatformTagApi extends ResourcesApi_1.ResourcesApi {
    get __resourcePath() {
        return "tags";
    }
    /**
     * Gets the {@link SdPlatformResponseTag} by id.
     * @param id - the id of a tag.
     * @returns the {@link SdPlatformGetResponse} with {@link SdPlatformResponseTag} or {@link SdPlatformResponseTagAdmin} as data.
     */
    get(id) {
        return super.__get(SdPlatformRequestId_1.RequestId.TagGet, id);
    }
    /**
     * Queries the {@link SdPlatformResponseTag} tags.
     * @param query {@link SdPlatformTagQueryParameters} - query parameters for tags.
     * @returns collection of {@link SdPlatformResponseTag} based on query parameters.
     */
    query(query = {}) {
        return super.__query(SdPlatformRequestId_1.RequestId.TagQuery, query);
    }
    /**
     * Patch a tag.
     * @param id - the id of a tag
     * @param body - {@link SdPlatformRequestTagPatch} as properties to patch.
     */
    patch(id, body) {
        return super.__patch(SdPlatformRequestId_1.RequestId.TagPatch, id, body);
    }
    /**
     * Delete a tag
     * @param id - the id of a tag
     */
    delete(id) {
        return super.__delete(SdPlatformRequestId_1.RequestId.TagDelete, id);
    }
}
exports.SdPlatformTagApi = SdPlatformTagApi;
//# sourceMappingURL=SdPlatformTagApi.js.map